import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ProgressSpinner } from 'primereact/progressspinner';

import { BarrioContext } from '../components/BarrioContext';
import { useAuth } from '../components/AuthContext';
import { useTerminologia } from '../hooks/useTerminologia';
import { ROL_PERFIL_ADMINISTRADOR } from '../constants/roles';

const DashboardGeneral = () => {
    const HOST_API = process.env.REACT_APP_URL;
    const navigate = useNavigate();
    const { seleccionarBarrio } = useContext(BarrioContext);
    const { administracionId, rolId } = useAuth();
    const t = useTerminologia();
    const esAdmin = rolId === 1 || rolId === ROL_PERFIL_ADMINISTRADOR;

    const [barrios, setBarrios] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!esAdmin) {
            navigate('/', { replace: true });
        }
    }, [esAdmin, navigate]);

    useEffect(() => {
        if (!esAdmin || !administracionId) return;

        setLoading(true);
        axios.get(`${HOST_API}api/barrios/GetBarriosConResumen?administracionId=${administracionId}`)
            .then((res) => setBarrios(res.data || []))
            .catch((err) => console.error('Error al obtener el resumen de barrios:', err))
            .finally(() => setLoading(false));
    }, [HOST_API, administracionId, esAdmin]);

    if (!esAdmin) return null;

    const handleSeleccionarBarrio = (b) => {
        seleccionarBarrio(b.barrioId, b.nombreBarrio, b.cuit, b.direccion, b.razonSocial, b.numeroCuenta, b.cuentaBancaria, b.tipoCuentaBancaria, b.alias);
        navigate('/');
    };

    return (
        <div>
            <h4>Dashboard General</h4>
            {/* <p style={{ color: '#667085', marginTop: -8 }}>
                Elegí un {t.barrio} para ver su Dashboard.
            </p> */}

            {loading ? (
                <div className="flex justify-content-center" style={{ padding: '3rem 0' }}>
                    <ProgressSpinner style={{ width: 50, height: 50 }} />
                </div>
            ) : barrios.length === 0 ? (
                <p>No hay {t.barrios} cargados todavía.</p>
            ) : (
                <div className="grid">
                    {barrios.map((b) => (
                        <div key={b.barrioId} className="col-12 md:col-6 lg:col-4 xl:col-3">
                            <div
                                onClick={() => handleSeleccionarBarrio(b)}
                                style={{
                                    background: '#F6F7F9',
                                    borderRadius: 22,
                                    padding: 14,
                                    boxShadow: '0 6px 16px -8px rgba(16,24,40,0.18)',
                                    cursor: 'pointer',
                                    transition: 'transform .15s, box-shadow .15s',
                                    width: '70%',
                                    margin: '0 auto',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 12px 24px -10px rgba(16,24,40,0.28)'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 6px 16px -8px rgba(16,24,40,0.18)'; }}
                            >
                                {/* ── Imagen con badge de estado ── */}
                                <div style={{ position: 'relative' }}>
                                    <div style={{
                                        height: 150,
                                        borderRadius: 16,
                                        background: b.imagenUrl
                                            ? `url("${`${HOST_API}${b.imagenUrl}`.replace(/([^:])\/\/+/g, '$1/')}") center/cover no-repeat`
                                            : 'linear-gradient(135deg, #4f8ff7, #0a3d91)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        {!b.imagenUrl && (
                                            <i className="pi pi-map-marker" style={{ fontSize: '2.4rem', color: 'rgba(255,255,255,0.85)' }} />
                                        )}
                                    </div>
                                    <span style={{
                                        position: 'absolute', top: 10, left: 10,
                                        background: 'rgba(255,255,255,0.92)', color: '#344054',
                                        fontSize: '0.72rem', fontWeight: 600,
                                        padding: '4px 10px', borderRadius: 999,
                                        boxShadow: '0 2px 6px rgba(16,24,40,0.15)',
                                    }}>
                                        {b.activo ? 'Activo' : 'Inactivo'}
                                    </span>
                                </div>

                                {/* ── Título + badge de UFs ── */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginTop: 12 }}>
                                    <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1d2939' }}>
                                        {b.nombreBarrio}
                                    </div>
                                    <span style={{
                                        flexShrink: 0,
                                        background: 'rgb(81, 147, 253)', color: '#fff',
                                        fontSize: '0.78rem', fontWeight: 700,
                                        padding: '5px 12px', borderRadius: 999,
                                    }}>
                                        {b.cantidadUF} {b.cantidadUF === 1 ? t.UF : `${t.UF}s`}
                                    </span>
                                </div>

                                {/* ── Dirección ── */}
                                <p style={{
                                    fontSize: '0.85rem', color: '#667085', marginTop: 6, marginBottom: 12,
                                    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                                }}>
                                    {b.direccion || 'Sin dirección cargada'}
                                </p>

                                {/* ── CTA ── */}
                                <button
                                    onClick={(e) => { e.stopPropagation(); handleSeleccionarBarrio(b); }}
                                    style={{
                                        width: '100%', border: 'none', cursor: 'pointer',
                                        background: 'rgb(81, 147, 253)', color: '#fff',
                                        fontSize: '0.9rem', fontWeight: 600,
                                        padding: '10px 0', borderRadius: 999,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                                    }}
                                >
                                    <i className="pi pi-chart-bar" />
                                    Ver Dashboard
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DashboardGeneral;
